module.exports = __webpack_public_path__ + "static/footer-logo-1884d9cb5d825e0a27dd1cabe0b7c862.png";